import React from "react";
import { useDispatch, useSelector } from 'react-redux';

import { Button } from "react-bootstrap";

import {
  setSiteSchedulesCoreEditing,
  setSiteSchedulesCoreSaving,
  setSiteSchedulesCoreResetting,
} from "services/redux/actions/singleSites";

function ScheduleFooter() {
  const dispatch = useDispatch();

  const { editing } = useSelector((state) => state.sites.current.schedules.core);

  return (
    <div
      className="pr-4 d-flex justify-content-center align-items-center"
      style={{ width: "100%", height: "100%" }}
    >
      {editing
        ? <div>
            <Button
              variant="primary"
              onClick={() => {
                dispatch(setSiteSchedulesCoreResetting({ value: true }));
              }}
            >Cancel</Button>
            <Button
              variant="success"
              className="ml-2"
              onClick={() => {
                dispatch(setSiteSchedulesCoreSaving({ value: true }));
              }}
            >Save</Button>
          </div>
        : <Button
            variant="primary"
            onClick={() => {
              dispatch(setSiteSchedulesCoreEditing({ value: true }));
            }}
          >Edit</Button>
      }
    </div>
  )
}

export default ScheduleFooter;